import { getIconFromType } from "../logic";
var useToast = function useToast(type) {
  var IconComponent = getIconFromType(type);
  return {
    IconComponent: IconComponent
  };
};
export default useToast;